var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fm-poper-select',{attrs:{"value":_vm.value,"confirm":_vm.confirm,"options":_vm.options,"multiple":_vm.multiple,"clearable":_vm.clearable},on:{"change":_vm.onChange}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }